import { apiClient } from './client';
import type { ApiResponse, PaginatedResponse, Campaign, CampaignStatus } from '@/types/api.types';

export const campaignsApi = {
  list: (params?: { page?: number; pageSize?: number; status?: CampaignStatus }) =>
    apiClient.get<PaginatedResponse<Campaign>>('/campaigns', { params }),

  get: (id: string) =>
    apiClient.get<ApiResponse<{ campaign: Campaign; stats: { total: number; pending: number; sent: number; delivered: number; read: number; failed: number } }>>(
      `/campaigns/${id}`,
    ),

  create: (data: { name: string; templateId: string; contactIds: string[]; fieldMappings?: Record<string, string>; scheduledAt?: string }) =>
    apiClient.post<ApiResponse<Campaign>>('/campaigns', data),

  start: (id: string) =>
    apiClient.post<ApiResponse<Campaign>>(`/campaigns/${id}/start`),

  cancel: (id: string) =>
    apiClient.post<ApiResponse<Campaign>>(`/campaigns/${id}/cancel`),
};
